import { Component, Input, OnInit } from '@angular/core';
import { AssistantPromptComponent } from '../../../../common/assistant-prompt/assistant-prompt.component';
import { Company } from '../../../../interfaces/company.interface';
import { NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppModule } from '../../../../app.module';
import { TruncatePipe } from '../../../../pipes/truncate.pipe';
import { NgTruncatePipeModule } from 'angular-pipes';
import { AppState } from 'src/app/state/app.state';
import { Store } from '@ngrx/store';
import { getGmails } from 'src/app/state/google/google.actions';
import {
  selectGmailsFailure,
  selectGmailsSuccess,
} from 'src/app/state/google/google.selectors';
import { Subscription, filter, take, takeUntil, tap } from 'rxjs';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth.service';
import { empty } from 'angular-pipes/utils/utils';
import {
  selectHubspotContactFailure,
  selectHubspotContactSuccess,
  selectHubspotDealsFailure,
  selectHubspotDealsSuccess,
  selectShowMoreHubspotDealsFailure,
  selectShowMoreHubspotDealsSuccess,
} from 'src/app/state/hubspot/hubspot.selectors';
import {
  getHubspotContact,
  getHubspotDeals,
  showMoreHubspotDeals,
} from 'src/app/state/hubspot/hubspot.actions';
import { clearHubspot } from 'src/app/state/search/search.actions';
interface TabItem {
  id: number;
  name: string;
  count: number;
  current: boolean;
}

interface ListItem {
  title: string;
  subtitle: string;
  preview: string;
  date: string;
  isRead?: boolean;
}

@Component({
  selector: 'app-emails',
  templateUrl: './emails.component.html',
  styleUrl: './emails.component.scss',
})
export class EmailsComponent implements OnInit {
  isLoadedDeals: boolean = true;
  contact: any;
  contact_id: any;
  isLoadedContact: boolean = true;

  page_deals: number = 1;
  added_deals: number;
  isConnectedToGmail: boolean;
  isConnectedToHubSpot: any;
  constructor(
    // private deviceService: DeviceService,
    private store: Store<AppState>,
    private authService: AuthService
  ) {}

  @Input() report: any;
  @Input() company: Company;
  user: any;
  isLoadedMail: any = true;
  ngOnInit(): void {
    if (this.report.email !== '' && this.report.email !== null) {
      this.getGoogleGmails();
    }

    this.authService.authUser().subscribe((user) => {
      this.user = user;
      this.isConnectedToHubSpot = this.user.has_connected_to_hubspot;
      this.isConnectedToGmail = this.user.has_connected_to_gmail;
    });
  }

  tabs: TabItem[] = [
    { id: 1, name: 'Messages', count: 28, current: true },
    { id: 2, name: 'Deals', count: 12, current: false },
  ];

  selectedTab = this.tabs[0];
  emails: any;
  messages: ListItem[] = [];

  deals: ListItem[] = [];

  // Sample pagination data
  pagination = {
    current_page: 1,
  };

  get currentList(): ListItem[] {
    return this.selectedTab.name === 'Messages' ? this.messages : this.deals;
  }

  selectTab(tab: TabItem) {
    this.tabs.forEach((t) => (t.current = false));
    tab.current = true;
    this.selectedTab = tab;
    if (tab.name == 'Deals') {
      this.page_deals = 1;
      this.pagination.current_page = 1;
      this.store.dispatch(clearHubspot());
      this.deals = [];
      this.getHubspotContact();
    }
    if (tab.name == 'Messages') {
      this.messages = [];
      this.getGoogleGmails();
    }
  }

  hasNextPage = true;

  onPageChanged(page: number) {
    if (page > this.pagination.current_page && !this.hasNextPage) {
      return;
    }

    if (this.tabs[0].current == true) {
      this.pagination.current_page = page;
      this.getGoogleGmails();
    } else {
      if (this.pagination.current_page < page) {
        this.pagination.current_page = page;

        this.page_deals += 1;
        this.isLoadedDeals = false;
        this.showMoreDeals();
      } else {
        this.pagination.current_page = page;

        this.page_deals -= 1;
        this.isLoadedDeals = false;
        this.showMoreDeals();
      }
    }
  }

  getGoogleGmails() {
    console.log('[emails.component.ts] getGoogleGmails')

    this.store.dispatch(getGmails({ email: this.report.email, page: this.pagination.current_page }));

    this.isLoadedMail = false;
    this.store
      .select(selectGmailsSuccess)
      .pipe(
        filter((gmails) => gmails !== null),
        take(1)
      )
      .subscribe({
        next: (gmails) => {
          if (gmails.messages && gmails.messages.length > 0) {
            this.messages = gmails.messages.map((item) => ({
              title: item.subject,
              subtitle: this.report.name,
              preview: item.snippet,
              date: moment(item.date).format('DD MMM YYYY'),
            }));

            this.hasNextPage = gmails.hasMorePages;
            this.isLoadedMail = true;
          } else {
            this.pagination.current_page--;
            this.hasNextPage = false;
            this.isLoadedMail = true;
          }
        },
        error: (error) => {
          console.error('Error in success subscription:', error);
          this.isLoadedMail = true;
          this.pagination.current_page--;
        },
      });

    this.store
      .select(selectGmailsFailure)
      .pipe(
        filter((error) => error !== null),
        take(1)
      )
      .subscribe({
        next: (error) => {
          console.log(error);

          this.isLoadedMail = true;
        },
        error: (error) => {
          console.error('Error in failure subscription:', error);
          this.isLoadedMail = true;
        },
      });
  }

  getHubspotContact() {
    this.isLoadedDeals = false;
    this.store.dispatch(getHubspotContact({ search_id: this.report.id }));

    const getHubspotContactSuccess$ = this.store.select(
      selectHubspotContactSuccess
    );
    const getHubspotContactFailure$ = this.store.select(
      selectHubspotContactFailure
    );

    let getHubspotContactSuccessSubscription: Subscription = null;
    let getHubspotContactFailureSubscription: Subscription = null;

    getHubspotContactSuccessSubscription = getHubspotContactSuccess$
      .pipe(
        filter((data) => data.hubspot_contact !== null),
        take(1)
      )
      .subscribe({
        next: (data) => {
          if (data.hubspot_contact == 'hubspot_does_not_exist') {
            this.contact = null;
          } else {
            this.contact = data.hubspot_contact[1];
            this.contact_id = data.hubspot_contact[0];
            this.getHubspotDeals();
          }
          if (getHubspotContactSuccessSubscription) {
            getHubspotContactSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Contact error:', error);

          this.isLoadedContact = true;
          if (getHubspotContactSuccessSubscription) {
            getHubspotContactSuccessSubscription.unsubscribe();
          }
        },
      });

    getHubspotContactFailureSubscription = getHubspotContactFailure$
      .pipe(
        filter((error) => error !== null),
        take(1)
      )
      .subscribe({
        next: (error) => {
          this.isLoadedDeals = true;
          this.contact = null;
          if (getHubspotContactFailureSubscription) {
            getHubspotContactFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.log('Hubspot Get Contact handling error:', error);
          if (getHubspotContactFailureSubscription) {
            getHubspotContactFailureSubscription.unsubscribe();
          }
        },
      });
  }

  getHubspotDeals() {
    this.store.dispatch(
      getHubspotDeals({
        contact_id: this.contact_id,
        search_id: this.report.id,
      })
    );

    const getHubspotDealsSuccess$ = this.store.select(
      selectHubspotDealsSuccess
    );
    const getHubspotDealsFailure$ = this.store.select(
      selectHubspotDealsFailure
    );

    let getHubspotDealsSuccessSubscription: Subscription = null;
    let getHubspotDealsFailureSubscription: Subscription = null;

    getHubspotDealsSuccessSubscription = getHubspotDealsSuccess$
      .pipe(
        filter(
          (data) => data.hubspot_deals != null && data.loadingHubspot != true
        ),
        take(1)
      )
      .subscribe({
        next: (data) => {
          this.deals = data.hubspot_deals.deals;

          this.deals = data.hubspot_deals.deals.map((item) => ({
            title: item.dealname,
            subtitle: this.report.name,
            preview: item.dealstage,
            date: moment(item.createdate).format('DD MMM YYYY'),
          }));

          if (data.hubspot_deals?.total === this.deals?.length)
            this.hasNextPage = false;

          this.isLoadedDeals = true;

          if (getHubspotDealsSuccessSubscription) {
            getHubspotDealsSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          // Handle error
          console.error('Hubspot Get Deals error:', error);
          this.isLoadedDeals = true;
          this.hasNextPage = false;
          if (getHubspotDealsSuccessSubscription) {
            getHubspotDealsSuccessSubscription.unsubscribe();
          }
        },
      });

    getHubspotDealsFailureSubscription = getHubspotDealsFailure$
      .pipe(
        filter((failure) => failure !== null),
        take(1)
      )
      .subscribe({
        next: (error) => {
          this.isLoadedDeals = true;
          this.hasNextPage = false;
          console.log(error);
          if (getHubspotDealsFailureSubscription) {
            getHubspotDealsFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot  Get Deals handling error:', error);
          this.isLoadedDeals = true;
          this.hasNextPage = false;
          if (getHubspotDealsFailureSubscription) {
            getHubspotDealsFailureSubscription.unsubscribe();
          }
        },
      });
  }

  showMoreDeals() {
    this.store.dispatch(
      showMoreHubspotDeals({
        contact_id: this.contact_id,
        search_id: this.report.id,
        page: this.page_deals,
      })
    );

    const showMoreHubspotDealsSuccess$ = this.store.select(
      selectShowMoreHubspotDealsSuccess
    );
    const showMoreHubspotDealsFailure$ = this.store.select(
      selectShowMoreHubspotDealsFailure
    );

    let showMoreHubspotDealsSuccessSubscription: Subscription = null;
    let showMoreHubspotDealsFailureSubscription: Subscription = null;

    showMoreHubspotDealsSuccessSubscription = showMoreHubspotDealsSuccess$
      .pipe(
        filter((data) => data.hubspot_deals != null),
        take(1)
      )
      .subscribe({
        next: (data) => {
          // this.deals = this.deals.concat(data.hubspot_deals.deals);

          this.deals = data.hubspot_deals.deals.map((item) => ({
            title: item.dealname,
            subtitle: this.report.name,
            preview: item.dealstage,
            date: moment(item.createdate).format('DD MMM YYYY'),
          }));

          if (data.hubspot_deals.total <= this.page_deals * 5)
            this.hasNextPage = false;
          else {
            this.hasNextPage = true;
          }
          this.isLoadedDeals = true;
          if (showMoreHubspotDealsSuccessSubscription) {
            showMoreHubspotDealsSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Show More Deals error:', error);
          this.isLoadedDeals = true;
          if (showMoreHubspotDealsSuccessSubscription) {
            showMoreHubspotDealsSuccessSubscription.unsubscribe();
          }
        },
      });

    showMoreHubspotDealsFailureSubscription = showMoreHubspotDealsFailure$
      .pipe(
        filter((failure) => failure !== null),
        take(1)
      )
      .subscribe({
        next: (error) => {
          console.log(error);
          this.isLoadedDeals = true;
          if (showMoreHubspotDealsFailureSubscription) {
            showMoreHubspotDealsFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          // Handle error in error handling
          console.error('Hubspot  Show More Deals handling error:', error);
          this.isLoadedDeals = true;
          if (showMoreHubspotDealsFailureSubscription) {
            showMoreHubspotDealsFailureSubscription.unsubscribe();
          }
        },
      });
  }
}
